export const API_BASE_URL = `${process.env.REACT_APP_API_URL}/chapters`;
export const PROPOSITION = `${process.env.REACT_APP_API_URL_RESSOURCES}/chapters`;
